const parser = (value: string): number => {
  // Remove double input spaces if present
  if (value.indexOf('.', value.indexOf('.') + 1) !== -1) {
    return 0
  }
  let numberString = value.replace(/[^\d.-]/g, '')
  return Number.parseFloat(numberString)
}

export default parser
